import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Stack, useMediaQuery, useTheme} from '@mui/material';
import {Snowfall} from 'react-snowfall';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const Main = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const snowflakeCount = isMobile ? 50 : 150;

    return (
        <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
            <Snowfall
                snowflakeCount={snowflakeCount}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    pointerEvents: 'none',
                    zIndex: 5,
                }}
            />
            <Stack className="no-scrollbar">
                <App />
            </Stack>
        </div>
    );
};

root.render(<Main />);

reportWebVitals();